export default __webpack_public_path__ + "static/media/preview-lottexmas.8517549f.png";